import { toSnakeCase } from './components/shared/to-snake-case'
import * as OfflinePluginRuntime from '@lcdp/offline-plugin/runtime'
OfflinePluginRuntime.install()
import i18n from './locales/i18n'

const config = {
    REACT_APP_CITY_OSTRAVA_URL: 'https://www.sportujvostrave.cz',
    REACT_APP_CITY_OLOMOUC_URL: 'https://www.sportujvolomouci.cz',
    REACT_APP_CITY_CHEB_URL: 'https://www.sportujvchebu.cz',

    REACT_APP_AVAILABLE_UNLOGGED_SHOW: '["eventSlug","clubId","sportVenueSlug"]',

    REACT_APP_MUST_BE_LOGGED_SUBPAGES: false,

    REACT_APP_SYSTEM: 'sportnect',
    REACT_APP_SYSTEM_NAME: 'Sportnect',
    REACT_APP_CONTACT_EMAIL: 'sportnect@sportnect.com',
    REACT_APP_INFO_EMAIL: 'mailto:info@sportnect.com',
    REACT_APP_SUPPORT_EMAIL: 'podpora@sportnect.com',

    REACT_APP_IOS_STORE: 'https://itunes.apple.com/cz/app/sportnect/id1404300192?l=cs',
    REACT_APP_ANDROID_STORE: 'https://play.google.com/store/apps/details?id=cz.sportnect',

    REACT_APP_LANDING_LOCATION_PATHNAME: '/',
    REACT_APP_LANDING_IMAGES_FOLDER: '/images/landing/',
    REACT_APP_SFN_IMAGES_FOLDER: '/images/sfn/',
    REACT_APP_IMAGES_FOLDER: '/images/sportnect/',
    REACT_APP_SUBPAGE_HEADER_IMAGES_FOLDER: '/images/subpage-headers/',
    REACT_APP_SUBPAGE_INFO_IMAGES_FOLDER: '/images/subpage-info/',
    REACT_APP_BROWSERS_IMAGES_FOLDER: '/images/browser/',

    REACT_APP_SHOW_STORE_BANNER: true,
    REACT_APP_SHOW_ACTUALITY: true,

    REACT_APP_FOOTER_FACEBOOK_LINK: 'https://facebook.com/sportnect/',
    REACT_APP_FOOTER_FACEBOOK_GROUP_LINK: 'https://www.facebook.com/groups/627479584758447',
    REACT_APP_FOOTER_INSTAGRAM_LINK: 'https://www.instagram.com/sportnectcom/',
    REACT_APP_FOOTER_TIKTOK_LINK: 'https://www.tiktok.com/@sportnectcom',
    REACT_APP_FOOTER_YOUTUBE_LINK: 'https://www.youtube.com/channel/UC5RRuNK1W5M2CUTwFCduz4A',
    REACT_APP_FOOTER_FACEBOOK_TAG: 'Sportnect',
    REACT_APP_FOOTER_INSTAGRAM_TAG: '#sportnect',
    REACT_APP_FOOTER_MOBILE_TEXT: i18n.t('downloadApp'),
    REACT_APP_FOOTER_SUB_LOGO: '<a href="https://www.sportnect.com" class="d-flex" target="_blank" rel="noopener noreferrer"><img src="/images/logo_sportnect_white.svg" alt="sportnect-logo" width="143" height="33" /></a>',
    REACT_APP_FOOTER_LANGUAGE: true,

    REACT_APP_SFN_FACEBOOK_LINK: 'https://www.facebook.com/simplefootballnetwork/',
    REACT_APP_SFN_INSTAGRAM_LINK: 'https://www.instagram.com/simplefootballnetwork/',

    REACT_APP_SPORTNECT_LANDING: true,
    REACT_APP_SPORTNECT_FOOTER: true,

    REACT_APP_SPORTNECT_ROUTES: true,

    REACT_APP_PASS_MARKERS_TO_CITY: false,
    REACT_APP_SPORT_VENUE_DETAIL: true,

    REACT_APP_YT_CREATE_EVENT_LINK: 'https://www.youtube.com/embed/fwBaoZB_bxA',
    REACT_APP_YT_CREATE_TOURNAMENT_1: 'https://www.youtube.com/embed/4iIub24LiMY',
    REACT_APP_YT_CREATE_TOURNAMENT_2: 'https://www.youtube.com/embed/dl4WPFxc_9A',

    REACT_APP_FOOTER_LINKS_LEFT: {
        'news/co-je-sportnect': 'aboutUs',
        'news/nas-pribeh': 'footerLinks.ourStory',
        'media': 'media',
        'mesta': 'cityPortals',
    },

    REACT_APP_FOOTER_LINKS_RIGHT: {
        'news/reference': 'footerLinks.references',
        'fanousek-sportovec': 'footerLinks.fans',
        'turnaje': 'footerLinks.tournaments',
        'trener': 'footerLinks.clubs',
        'rodice-a-deti': 'footerLinks.parents',
        'pridat-sportoviste': 'footerLinks.venues',
        'news/zajimave-sportovni-akce': 'footerLinks.actions',
    },

    REACT_APP_REDIRECT_GROUP_MEMBERS: true,

    REACT_APP_ENTITIES_DEFAULT_COUNT: 8,
    REACT_APP_ENTITIES_LOAD_USERS: true,

    REACT_APP_DEFAULT_DESCRIPTION: i18n.t('appDefaultDescription'),

    REACT_APP_TRANSLATION_ROUTES: {
        entities: 'entities',
        events: 'events',
        clubs: 'clubs',
        sportVenues: 'sport-venues',
        community: 'community',
        sportnections: 'sportnections',
        notifications: 'notifications',
        chat: 'chat',
        news: 'news',
        contact: 'contact',
    },

    REACT_APP_DEFAULT_LAT: '49.819657',
    REACT_APP_DEFAULT_LNG: '18.0973114',

    REACT_APP_AUTH_ROUTES: {
        login: 'login',
        signup: 'signup',
        forgottenPassword: 'forgotten-password',
        signpostLoginRoute: 'login-signpost',
    },

    REACT_APP_BLOG_BANNERS: [
        {
            image: '/images/banners/banner-turnaje.jpg',
            url: 'https://www.sportnect.com/turnaje',
            alt: '',
            title: '',
        },
        {
            image: '/images/banners/banner-sporto.jpg',
            url: 'https://www.sporto.cz/',
            alt: i18n.t('ad.banners.sporto.title'),
            title: i18n.t('ad.banners.sporto.title'),
        },
    ],

    REACT_APP_WEBVIEW_AUTH_FACEBOOK: true,
    REACT_APP_SPORTNECT_ORGANIZERS: true,
}

const dataset = document.getElementById('platform-body').dataset
const dataConfig = Object.keys(dataset).reduce((element, key) => (element['REACT_APP_' + toSnakeCase(key).toUpperCase()] = dataset[key], element), {})

window.APP_CONFIG = Object.assign({}, config, dataConfig)

require('./index')
